import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconUIComponent } from '@shared-ui-kit';

@Component({
  selector: 'fr8bot-web-critical-freight-card',
  templateUrl: './web-critical-freight-card.html',
  styleUrl: './web-critical-freight-card.scss',
  imports: [IconUIComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WebCriticalFreightCard {
  number = input(1);
  title = input('');
  description = input('');
}
